export const AstIdParam = {
    compose({ astId }) {
        return astId ? `astId=${astId}` : '';
    },
};
